import Section from "../section/Section";
import { Button } from "../../../../src/modules/_common/components/Button";
import useTypeForm from "../../hooks/useTypeForm";

const MotionSection = ({ ctaType = "form" }) => {
	const freeConsultationForm = useTypeForm("R6iu6OZO");
	const handleClick = () => {
		if (ctaType === "form") {
			freeConsultationForm.open();
		} else {
			window.open(process.env.GATSBY_GET_ACCESS_BUTTON, "_blank");
		}
	};
	return (
		<Section className="motion-section my-8 my-md-13 pt-8 pb-10 pt-md-19 pb-md-20 px-4 bg-pink">
			<div className="mx-auto text-center">
				<h2 className="pb-4 pb-md-7 mx-auto " style={{ maxWidth: 466 }}>
					Set your future in motion
				</h2>

				<p className="font-size-xl m-0 pb-4 pb-md-8 mx-auto" style={{ maxWidth: 449 }}>
					This is your first step. Find a time that’s convenient and book a <span className="text-underline">FREE</span>{" "}
					consultation.
				</p>

				<Button onClick={handleClick} className="btn-cornered btn-white">
					I’m ready, let’s do this!
				</Button>
			</div>
		</Section>
	);
};

export default MotionSection;
